import { createFileRoute } from '@tanstack/react-router'
import { AdministratorsPage } from '@/features/administrators'

export const Route = createFileRoute('/_authenticated/_organization/users/')({
  component: AdministratorsPage,
})
